// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2876":"1f801112","3389":"1776bb2f","5159":"18cc5d82"}[chunkId] + ".chunk.css";
};